// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"Slider_swiperContainer__13fJE","swiperWrapper":"Slider_swiperWrapper__2t7yx","swiperPagination":"Slider_swiperPagination__3OUqB","slider":"Slider_slider__9I4DJ"};